import styled from "styled-components";

const StyledRect = styled.rect`
  fill: ${(props) => props.theme.backgroundColor};
`

const Ship = ({num}) => {
   
  const shipImages = [
  <g>
    <g>
      <path d="M3196.1,2667.5a121.22,121.22,0,0,0-78.83-78.83L3268,2516.75Z"/>
      <path d="M3253.87,2530.9l-57.08,119.64a129.08,129.08,0,0,0-62.56-62.56l119.64-57.08m28.31-28.31-186.06,88.77h0c49,4.21,93.06,48.28,97.28,97.28l88.77-186.06Z"/>
    </g>
    <g>
      <StyledRect x="3327.26" y="2440.06" width="151.94" height="151.94"/>
      <path d="M3469.79,2450.06v132.53H3337.26V2450.06h132.53m10-10H3327.26v152.53h152.53V2440.06Z"/>
      <path d="M3398.77,2488.7h-17.25V2477c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
    </g>
  </g>,

  <g>
    <g>
      <path d="M1421.35,897.58a121.27,121.27,0,0,0-78.83-78.83l150.75-71.92Z"/>
      <path d="M1479.12,761,1422,880.62a129.16,129.16,0,0,0-62.56-62.56L1479.12,761m28.31-28.3-186.06,88.77h0c49,4.22,93.06,48.28,97.27,97.29l88.78-186.06Z"/>
    </g>
    <g>
      <StyledRect x="1552.5" y="670.14" width="151.94" height="151.94"/>
      <path d="M1695,680.14V812.68H1562.5V680.14H1695m10-10H1552.5V822.68H1705V670.14Z"/>
      <path d="M1624,718.79h-17.25v-11.7c14,0,18.9-3,22.65-13.2h11.1v105H1624Z"/>
    </g>
  </g>,

  <g>
    <g>
      <path d="M2424.19,322.58a121.22,121.22,0,0,0-78.83-78.83l150.75-71.92Z"/>
      <path d="M2482,186l-57.08,119.64a129.16,129.16,0,0,0-62.56-62.56L2482,186m28.31-28.3-186.06,88.77h0c49,4.22,93.06,48.28,97.28,97.29h0l88.77-186.06Z"/>
    </g>
    <g>
      <StyledRect x="2555.35" y="95.14" width="151.94" height="151.94"/>
      <path d="M2697.88,105.14V237.68H2565.34V105.14h132.54m10-10H2555.34V247.68h152.54V95.14Z"/>
      <path d="M2626.86,143.78h-17.25V132.09c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
    </g>
  </g>
   ]

  const index = num-1
  return (
    shipImages[index]
  )
}

export default Ship
